import { IBasicCancelProceedPopupProps } from '../../../../components/popups/BasicCancelProceedPopup/BasicCancelProceedPopup.types';
import BasicCancelProceedPopup from '../../../../components/popups/BasicCancelProceedPopup/BasicCancelProceedPopup';

const RemoveAutopayPopup = (props: IBasicCancelProceedPopupProps) => {
    const { showPopup, onDialogClose } = props;

    return (
        <BasicCancelProceedPopup
            showPopup={showPopup}
            popupHeader={'Are You Sure?'}
            popupText={
                'Removing Autopay will remove any associated discounts from your monthly bill.'
            }
            onDialogClose={onDialogClose}
        />
    );
};

export default RemoveAutopayPopup;
